/*
  This contains the state for the editor. It's just client side state that needs to be globally accessible.
*/

import { create } from "zustand";
import { combine } from "zustand/middleware";

type State = {
  isPreview: boolean;
  renderPanelSize: {
    width: number | null;
    height: number | null;
  };
};

type SetState = {
  setIsPreview: (isPreview: boolean) => void;
  setRenderPanelSize: (renderPanelSize: State["renderPanelSize"]) => void;
};

export const useEditorStore = create(
  combine<State, SetState>(
    {
      isPreview: false,
      renderPanelSize: {
        width: null,
        height: null,
      },
    },
    (set) => ({

      setIsPreview: (isPreview) =>
        set((state) => ({
          ...state,
          isPreview,
        })),

      setRenderPanelSize: (renderPanelSize) =>
        set((state) => ({
          ...state,
          renderPanelSize,
        })),
    }),
  ),
);
